import { rgba } from 'polished'

export const themeColors = {
  light: {
    app: {
      headerToggleColor: '#0f6076',
      appSecondaryColor: '#edf6fb',
      sidebarBGColor: '#071b4a',
      sidebarFillColor: '#e8fbff',
      paperColor: '#ffffff',
      headerGradient: 'linear-gradient(115deg, #071b4a 0%, #0b4964 52%, #087f8c 100%)',
      workspaceGlow: 'rgba(8, 127, 140, 0.12)',
      workspaceLine: 'rgba(7, 27, 74, 0.045)',
      controlBG: 'rgba(255, 255, 255, 0.12)',
      controlBorder: 'rgba(255, 255, 255, 0.24)',
      headerShadow: '0 14px 36px rgba(7, 27, 74, 0.2)',
      textMuted: '#5f7287',
    },
    torrentCard: {
      accentCardColor: '#087f8c',
      buttonBGColor: '#0b6680',
      cardPrimaryColor: 'rgba(255, 255, 255, 0.92)',
      cardSecondaryColor: '#edf8fa',
      cardBorderColor: 'rgba(8, 127, 140, 0.18)',
      cardShadow: '0 18px 40px rgba(16, 42, 67, 0.12)',
    },
    dialogTorrentDetailsContent: {
      posterBGColor: '#74c39c',
      gradientStartColor: '#e4f6ed',
      gradientEndColor: '#b5dec9',
      chacheSectionBGColor: '#88cdaa',
      widgetFontColor: '#fff',
      titleFontColor: '#000',
      subNameFontColor: '#7c7b7c',
      torrentFilesSectionBGColor: '#f1eff3',
    },
    detailedView: {
      gradientStartColor: '#e4f6ed',
      gradientEndColor: '#b5dec9',
      cacheSectionBGColor: '#fff',
    },
    addDialog: {
      gradientStartColor: '#f8fcff',
      gradientEndColor: '#dff2f7',
      fontColor: '#102a43',
      notificationErrorBGColor: '#cda184',
      notificationSuccessBGColor: 'rgba(255, 255, 255, 0.92)',
      languageSwitchBGColor: '#e0f6f8',
      languageSwitchFontColor: '#0b4964',
      posterBGColor: '#d7eef4',
      emptyStateBorder: 'rgba(8, 127, 140, 0.2)',
      emptyStateShadow: '0 24px 60px rgba(7, 27, 74, 0.14)',
      emptyStateText: '#19364d',
    },
    torrentFunctions: {
      fontColor: '#000',
    },
    table: {
      defaultPrimaryColor: '#009879',
      defaultSecondaryColor: '#00a383',
      defaultTertiaryColor: '#03aa89',
      dividerColor: 'rgba(8, 127, 140, 0.14)',
      rowColor: 'rgba(255, 255, 255, 0.86)',
      viewedRowColor: '#e2ebee',
      textColor: '#17324a',
      mutedTextColor: '#486579',
      tableBorderColor: 'rgba(8, 127, 140, 0.2)',
      tableShadow: '0 14px 34px rgba(16, 42, 67, 0.11)',
      actionColor: '#087f8c',
      actionBorderColor: 'rgba(8, 127, 140, 0.5)',
      actionBackground: 'rgba(255, 255, 255, 0.45)',
      actionHoverBackground: 'rgba(8, 127, 140, 0.09)',
    },
    settingsDialog: {
      contentBG: '#edf5f9',
      footerBG: 'rgba(255, 255, 255, 0.96)',
      featureBG: 'rgba(255, 255, 255, 0.88)',
      featureBorder: 'rgba(8, 127, 140, 0.18)',
      featureShadow: '0 14px 34px rgba(16, 42, 67, 0.09)',
      featureMuted: '#64798d',
    },
  },
  dark: {
    app: {
      headerToggleColor: '#15394a',
      appSecondaryColor: '#08111f',
      sidebarBGColor: '#060d18',
      sidebarFillColor: '#ddfbff',
      paperColor: '#101d2c',
      headerGradient: 'linear-gradient(115deg, #040a14 0%, #0a1728 54%, #0b3d49 100%)',
      workspaceGlow: 'rgba(53, 208, 186, 0.12)',
      workspaceLine: 'rgba(134, 232, 229, 0.05)',
      controlBG: 'rgba(145, 238, 229, 0.08)',
      controlBorder: 'rgba(145, 238, 229, 0.16)',
      headerShadow: '0 16px 40px rgba(0, 0, 0, 0.45)',
      textMuted: '#8ea9bc',
    },
    torrentCard: {
      accentCardColor: '#52d8c6',
      buttonBGColor: '#12394a',
      cardPrimaryColor: 'rgba(16, 29, 44, 0.94)',
      cardSecondaryColor: '#14283a',
      cardBorderColor: 'rgba(82, 216, 198, 0.16)',
      cardShadow: '0 22px 48px rgba(0, 0, 0, 0.38)',
    },
    dialogTorrentDetailsContent: {
      posterBGColor: rgba('#dee3e5', 0.4),
      gradientStartColor: '#656f76',
      gradientEndColor: '#545a5e',
      chacheSectionBGColor: '#3c4244',
      widgetFontColor: rgba('#fff', 0.8),
      titleFontColor: '#f1eff3',
      subNameFontColor: '#dee3e5',
      torrentFilesSectionBGColor: rgba('#545a5e', 0.9),
    },
    detailedView: {
      gradientStartColor: '#656f76',
      gradientEndColor: '#545a5e',
      cacheSectionBGColor: '#949ca0',
    },
    addDialog: {
      gradientStartColor: '#14283a',
      gradientEndColor: '#0d1a29',
      fontColor: '#eefcff',
      notificationErrorBGColor: '#c82e3f',
      notificationSuccessBGColor: 'rgba(16, 29, 44, 0.94)',
      languageSwitchBGColor: '#173a49',
      languageSwitchFontColor: '#dcfbff',
      posterBGColor: '#183448',
      emptyStateBorder: 'rgba(82, 216, 198, 0.18)',
      emptyStateShadow: '0 28px 70px rgba(0, 0, 0, 0.42)',
      emptyStateText: '#edfaff',
    },
    torrentFunctions: {
      fontColor: '#f1eff3',
    },
    table: {
      defaultPrimaryColor: '#323637',
      defaultSecondaryColor: rgba('#545a5e', 0.9),
      defaultTertiaryColor: '#545a5e',
      dividerColor: 'rgba(82, 216, 198, 0.12)',
      rowColor: '#142331',
      viewedRowColor: '#1b3442',
      textColor: '#e8f7fb',
      mutedTextColor: '#a5bdc9',
      tableBorderColor: 'rgba(82, 216, 198, 0.18)',
      tableShadow: '0 16px 38px rgba(0, 0, 0, 0.28)',
      actionColor: '#9beee4',
      actionBorderColor: 'rgba(82, 216, 198, 0.52)',
      actionBackground: 'rgba(82, 216, 198, 0.055)',
      actionHoverBackground: 'rgba(82, 216, 198, 0.14)',
    },
    settingsDialog: {
      contentBG: '#0b1624',
      footerBG: 'rgba(10, 23, 40, 0.98)',
      featureBG: 'rgba(18, 36, 53, 0.9)',
      featureBorder: 'rgba(82, 216, 198, 0.16)',
      featureShadow: '0 18px 42px rgba(0, 0, 0, 0.32)',
      featureMuted: '#91aabc',
    },
  },
}

export const mainColors = {
  light: {
    primary: '#087f8c',
    secondary: '#087f8c',
    labels: '#17324a',
  },
  dark: {
    primary: '#0a1728',
    secondary: '#52d8c6',
    labels: '#e8f7fb',
  },
}
